import React from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Jumbotron, Row } from 'react-bootstrap';
import classNames from 'classnames';

const renderTitles = (title, subtitle) => {
  if (!title && !subtitle) {
    return null;
  }

  return (
    <h1 className="PageTitle-title">
      {title}
      {subtitle && (
        <React.Fragment>
          <br />
          <small className="PageTitle-subtitle">{subtitle}</small>
        </React.Fragment>
      )}
    </h1>
  );
};

const PageTitle = ({
  className, title, subtitle, children,
}) => {
  const PageTitleClasses = classNames('PageTitle', className);
  return (
    <Jumbotron className={PageTitleClasses}>
      <Grid>
        <Row>
          <Col md={12}>
            {renderTitles(title, subtitle)}
            {children}
          </Col>
        </Row>
      </Grid>
    </Jumbotron>
  );
};

PageTitle.propTypes = {
  /** Additional CSS class. */
  className: PropTypes.string,
  /** Page title. */
  title: PropTypes.string,
  /** Page subtitle. */
  subtitle: PropTypes.string,
  /** Any renderable nodes. */
  children: PropTypes.node,
};

PageTitle.defaultProps = {
  className: null,
  title: null,
  subtitle: null,
  children: null,
};

export default PageTitle;
